import type { Step } from "react-joyride";

export const serviceStandardDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດມາດຕະຖານບໍລິການ! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງມາດຕະຖານບໍລິການ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການມາດຕະຖານບໍລິການດ້ວຍປຸ່ມ 'ກັບ', ເບິ່ງ PDF Preview ດ້ວຍປຸ່ມ 'ເບິ່ງ PDF Preview', ຫຼືແກ້ໄຂມາດຕະຖານບໍລິການນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງມາດຕະຖານບໍລິການ. ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ຊ່ອງທາງບໍລິການ, ຕຳແໜ່ງ, ຜະແນກ, ໃຊ້ເວລາໃດ (ກ່ອນ/ລະຫວ່າງ/ຫຼັງບໍລິການ), ແລະສະຖານະ (ໃຊ້ງານ/ປັບປຸງ/ເລີກໃຊ້) ຂອງມາດຕະຖານບໍລິການນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-do-items"]',
    content:
      "ນີ້ແມ່ນພາກສິ່ງທີ່ຕ້ອງເຮັດ. ທ່ານຈະເຫັນລາຍການສິ່ງທີ່ຕ້ອງເຮັດທັງໝົດທີ່ກຳນົດໃນມາດຕະຖານບໍລິການນີ້. ສຳລັບແຕ່ລະລາຍການ, ທ່ານຈະເຫັນຂໍ້ຄວາມສິ່ງທີ່ຕ້ອງເຮັດແລະຄຳອະທິບາຍເພີ່ມເຕີມ (ຖ້າມີ).",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-dont-items"]',
    content:
      "ນີ້ແມ່ນພາກສິ່ງທີ່ຫ້າມເຮັດ. ທ່ານຈະເຫັນລາຍການສິ່ງທີ່ຫ້າມເຮັດທັງໝົດທີ່ກຳນົດໃນມາດຕະຖານບໍລິການນີ້. ສຳລັບແຕ່ລະລາຍການ, ທ່ານຈະເຫັນຂໍ້ຄວາມສິ່ງທີ່ຫ້າມເຮັດແລະຄຳອະທິບາຍເພີ່ມເຕີມ (ຖ້າມີ).",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-examples"]',
    content:
      "ນີ້ແມ່ນພາກຕົວຢ່າງປະໂຫຍກ. ທ່ານຈະເຫັນຕົວຢ່າງປະໂຫຍກທີ່ສາມາດໃຊ້ໃນສະຖານະການຕ່າງໆ ຕາມມາດຕະຖານບໍລິການນີ້. ສຳລັບແຕ່ລະຕົວຢ່າງ, ທ່ານຈະເຫັນສະຖານະການ, ຕົວຢ່າງປະໂຫຍກ, ແລະຄຳອະທິບາຍເພີ່ມເຕີມ (ຖ້າມີ).",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-special-cases"]',
    content:
      "ນີ້ແມ່ນພາກກໍລະນີພິເສດ. ທ່ານຈະເຫັນກໍລະນີພິເສດທີ່ອາດຈະເກີດຂຶ້ນແລະວິທີການຈັດການກັບກໍລະນີເຫຼົ່ານັ້ນຕາມມາດຕະຖານບໍລິການນີ້. ສຳລັບແຕ່ລະກໍລະນີພິເສດ, ທ່ານຈະເຫັນຊື່, ວິທີການຈັດການ, ແລະຄຳອະທິບາຍເພີ່ມເຕີມ (ຖ້າມີ).",
    placement: "top",
  },
];
